import { useState } from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Bell } from "lucide-react";

export const NotificationSettings = () => {
  const [monthlyReports, setMonthlyReports] = useState(true);
  const [reviewReminders, setReviewReminders] = useState(true);
  const [receiptAlerts, setReceiptAlerts] = useState(true);

  return (
    <Card>
      <CardHeader>
        <div className="flex items-center gap-2">
          <Bell className="h-5 w-5" />
          <CardTitle>Notifications</CardTitle>
        </div>
        <CardDescription>
          Control what notifications you receive
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="flex items-center justify-between">
          <div className="space-y-0.5">
            <Label>Monthly Reports</Label>
            <p className="text-sm text-muted-foreground">
              Get monthly expense summaries
            </p>
          </div>
          <Switch
            checked={monthlyReports}
            onCheckedChange={setMonthlyReports}
          />
        </div>

        <div className="flex items-center justify-between">
          <div className="space-y-0.5">
            <Label>Review Reminders</Label>
            <p className="text-sm text-muted-foreground">
              Reminders to review receipts
            </p>
          </div>
          <Switch
            checked={reviewReminders}
            onCheckedChange={setReviewReminders}
          />
        </div>

        <div className="flex items-center justify-between">
          <div className="space-y-0.5">
            <Label>Receipt Alerts</Label>
            <p className="text-sm text-muted-foreground">
              Alerts when receipts are processed
            </p>
          </div>
          <Switch
            checked={receiptAlerts}
            onCheckedChange={setReceiptAlerts}
          />
        </div>
      </CardContent>
    </Card>
  );
};
